export default ({ fill }) => (
  /**
   * Ícone utilizado para alinhamento do
   * rótulo ao rodapé da feição
   */
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.6393 17.2174H0.972656V15.5508H17.6393V17.2174ZM7.63932 0.550781H5.13932V13.8841H7.63932V0.550781ZM13.4727 5.55078H10.9727V13.8841H13.4727V5.55078Z"
      fill={fill || '#797E82'}
    />
  </svg>
);
